import { ICustomer } from '@app/core/models/customer.model';
import { ICustomerOthers } from '../../core/models/customer.model';

export class Customer {
  public id: string;
  public external_id: string;
  public status: string;
  public display_name: string;
  public phone_number: string;
  public website: string;

  public first_name: string;
  public middle_name: string;
  public second_surname: string;
  public first_surname: string;
  public occupation: string;

  public others: ICustomerOthers;

  constructor(customer: ICustomer) {
    this.id = customer.id;
    this.external_id = customer.external_id;
    this.status = customer.status;
    this.display_name = customer.display_name;
    this.phone_number = customer.phone_number;
    this.website = customer.website;

    this.first_name = customer.others?.first_name ?? '';
    this.middle_name = customer.others?.middle_name ?? '';
    this.second_surname = customer.others?.second_surname ?? '';
    this.first_surname = customer.others?.first_name ?? '';
    this.occupation = customer.others?.occupation ?? '';
  }
}
